"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortNumbersCompareFn = exports.normalizeIntegerNumber = exports.normalizeFloatNumber = exports.formatOrdinals = exports.toFixedTrimmed = exports.isNumber = void 0;
function isNumber(value) {
  return typeof value === 'number' && !isNaN(value);
}
exports.isNumber = isNumber;
function toFixedTrimmed(num, precision) {
  return Number(num.toFixed(precision));
}
exports.toFixedTrimmed = toFixedTrimmed;
const pluralRules = new Intl.PluralRules('en-US', {
  type: 'ordinal'
});
const suffixes = new Map([['one', 'st'], ['two', 'nd'], ['few', 'rd'], ['other', 'th']]);
const formatOrdinals = n => {
  const rule = pluralRules.select(n);
  const suffix = suffixes.get(rule);
  return "".concat(n).concat(suffix);
};
exports.formatOrdinals = formatOrdinals;
const normalizeFloatNumber = value => value ? parseFloat(value) : value;
exports.normalizeFloatNumber = normalizeFloatNumber;
const normalizeIntegerNumber = value => value ? parseInt(value) : value;
exports.normalizeIntegerNumber = normalizeIntegerNumber;
const sortNumbersCompareFn = (a, b) => a - b;
exports.sortNumbersCompareFn = sortNumbersCompareFn;